import { css } from 'linaria';

export const sectionStyle = css`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
`;
